import { alternativeApiUrl } from '@/config/endpoints';

export default {
  ID() {
    return '_' + Math.random().toString(36).substr(2, 9);
  },

  focusElement(id) {
    const el = document.getElementById(id);
    setTimeout(function () {
      if (el) el.focus();
    }, 100);
  },

  isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  },

  parseJSONObject (jsonString){
    try {
      const o = jsonString ? JSON.parse(jsonString) : null;

      if (o && typeof o === "object") {
        return o;
      }
    }
    catch (e) { }
    return false;
  },

  verificarServerAlternativo(login) {
    const isAlternativo = (localStorage.getItem('base_server') || "") === alternativeApiUrl;

    if (!isAlternativo) {
      localStorage.setItem('base_server', alternativeApiUrl);

      setTimeout(() => {
        window.location.reload();
      }, 2000);

      return "Conectando ao servidor alternativo." + (login ? " Faça seu login novamente." : "");

    } else {
      localStorage.removeItem('base_server');
      return "No momento este canal está indisponível.\nPor favor verifique se sua conexão está estável."
    }
  }
};
